import { render, staticRenderFns } from "./EditStaff.vue?vue&type=template&id=57df13bf&"
import script from "./EditStaff.vue?vue&type=script&lang=js&"
export * from "./EditStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports